import { EXCLUDED_PM_ENTITYID_FOR_CHATBOT } from "../constants";
export default function ChatbotNotAccessible(userDetails) {
    if(userDetails && userDetails.pmEntityID && Object.values(EXCLUDED_PM_ENTITYID_FOR_CHATBOT).includes(userDetails.pmEntityID)) {
        return true;
    }
    if(!userDetails) return true;
    return false;
}